import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProjectProvider, useProject } from "./context/ProjectContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import NoProjectState from "./components/NoProjectState";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AlleProjekte from "./pages/AlleProjekte";
import Produkte from "./pages/Produkte";
import Leads from "./pages/Leads";
import Pipeline from "./pages/Pipeline";
import KiAgent from "./pages/KiAgent";
import BildStudio from "./pages/BildStudio";
import Protokoll from "./pages/Protokoll";
import Digest from "./pages/Digest";
import Skills from "./pages/Skills";
import Seiten from "./pages/Seiten";
import SeitenEditor from "./pages/SeitenEditor";
import SocialPosts from "./pages/SocialPosts";
import Einstellungen from "./pages/Einstellungen";
import Verbindungen from "./pages/Verbindungen";
import VideoStudio from "./pages/VideoStudio";
import Berichte from "./pages/Berichte";
import OfferPublic from "./pages/OfferPublic";
import LandingPublic from "./pages/LandingPublic";
import VideoPublic from "./pages/VideoPublic";
import { Toaster } from "./components/ui/sonner";

// Wrap scoped pages: if no project is active, show empty-state instead.
function Scoped({ children }) {
  const { activeProject, loading } = useProject();
  if (loading) return <div className="p-8 text-slate-500" data-testid="project-loading">Lade Projekt…</div>;
  if (!activeProject) return <NoProjectState />;
  return children;
}

function AppShell({ children, requireProject = true }) {
  return (
    <ProtectedRoute>
      <Layout>{requireProject ? <Scoped>{children}</Scoped> : children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProjectProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/angebot/:token" element={<OfferPublic />} />
            <Route path="/p/:slug" element={<LandingPublic />} />
            <Route path="/v/:token" element={<VideoPublic />} />
            <Route path="/" element={<AppShell><Dashboard /></AppShell>} />
            <Route path="/alle-projekte" element={<AppShell requireProject={false}><AlleProjekte /></AppShell>} />
            <Route path="/produkte" element={<AppShell><Produkte /></AppShell>} />
            <Route path="/leads" element={<AppShell><Leads /></AppShell>} />
            <Route path="/pipeline" element={<AppShell><Pipeline /></AppShell>} />
            <Route path="/ki-agent" element={<AppShell><KiAgent /></AppShell>} />
            <Route path="/bild-studio" element={<AppShell><BildStudio /></AppShell>} />
            <Route path="/skills" element={<AppShell><Skills /></AppShell>} />
            <Route path="/seiten" element={<AppShell><Seiten /></AppShell>} />
            <Route path="/seiten/:id" element={<AppShell><SeitenEditor /></AppShell>} />
            <Route path="/social" element={<AppShell><SocialPosts /></AppShell>} />
            <Route path="/video-studio" element={<AppShell><VideoStudio /></AppShell>} />
            <Route path="/berichte" element={<AppShell><Berichte /></AppShell>} />
            <Route path="/digest" element={<AppShell><Digest /></AppShell>} />
            <Route path="/einstellungen" element={<AppShell requireProject={false}><Einstellungen /></AppShell>} />
            <Route path="/verbindungen" element={<AppShell><Verbindungen /></AppShell>} />
            <Route path="/protokoll" element={<AppShell><Protokoll /></AppShell>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors duration={3500} />
      </ProjectProvider>
    </AuthProvider>
  );
}

export default App;
